export { default } from './BarPage'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Layout/BarPage/index.js